module.exports = __webpack_public_path__ + "static/media/wangan.f260777a.mp4";